import React, { useEffect, useState } from "react";
import { Box, Typography, Tabs, Tab } from "@mui/material";
import { useProjectApi } from "../../../hooks/useProjectApi";
import AllProjectHistory from "../../ProjectHistory/AllProjectHistory";
import AllProjectMilestoneHistory from "../../ProjectMilestone/ProjectMilestoneHistory/AllProjectMilestoneHistory";

const a11yProps = (index) => ({
  id: `sub-tab-${index}`,
  "aria-controls": `sub-tabpanel-${index}`,
});

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`sub-tabpanel-${index}`}
    aria-labelledby={`sub-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
  </div>
);

const ProjectHistoryDetails = ({ projectId }) => {
  const [tabValue, setTabValue] = useState(0);
  const { getProjectById } = useProjectApi();
  const [projectDetails, setProjectDetails] = useState({});

  useEffect(() => {
    fetchProjectDetails();
  }, [projectId]);

  const fetchProjectDetails = async () => {
    const res = await getProjectById(projectId);
    setProjectDetails({
      name: res?.data?.project_name,
      description: res?.data?.project_description,
    });
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        aria-label="project-history-tabs"
        sx={{ borderBottom: 1, borderColor: "divider", mt: 2 }}
      >
        <Tab
          label="Project Change Log"
          sx={{ textTransform: "none" }}
          {...a11yProps(0)}
        />
        <Tab
          label="Milestone Change Log"
          sx={{ textTransform: "none" }}
          {...a11yProps(1)}
        />
      </Tabs>

      <TabPanel value={tabValue} index={0}>
        <AllProjectHistory projectId={projectId} />
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <AllProjectMilestoneHistory projectId={projectId} />
      </TabPanel>
    </Box>
  );
};

export default ProjectHistoryDetails;
